<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/4start#chap1">The Last Summer</a></p>
<p class="toc1"><a href="#/5chap2#chap2">The Waiting Months</a></p>
<p class="toc1"><a href="#/6chap3#chap3">A Christmas Tragedy</a></p>
<p class="toc1"><a href="#/7chap4#chap4">The Engagement</a></p>
<p class="toc1"><a href="#/8chap5#chap5">The Ghost in the Garden</a></p>
<p class="toc1"><a href="#/9chap6#chap6">The Treasure Hunt</a></p>
<p class="toc1"><a href="#/10chap7#chap7">Nightmare</a></p>
<p class="toc1"><a href="#/11chap8#chap8">Blackmail</a></p>
<p class="toc1"><a href="#/12chap9#chap9">Missing Person</a></p>
<p class="toc1"><a href="#/13chap10#chap10">The Devil’s Crown</a></p>
<p class="toc1"><a href="#/14chap11#chap11">Confession</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/15preview#preview">Preview: <i>Black Swan</i></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-TOC.vue?5c536347